module.exports = __webpack_public_path__ + "img/stake_section.32a79eff.jpg";